<template>
  <div
    class="panel-boot"
  >
    <template v-for="(item,index) in imgsrcDesc">
      <div :key="index">
        <img
          v-if="item.Type === 'img'"
          class=""
          :src="item.Value"
          style="width: 240px;"
        >
        <div
          v-if="item.Type==='txt'"
          class=" txt"
        >
          {{ item.Value }}
        </div>
      </div>
    </template>
    <div
      v-if="isShow && !deviceOnly"
      class="checked-bottom"
      @click="handleChecked"
    >
      {{ $t('deviceMsg.otabootTrue') }}
    </div>
  </div>
</template>

<script>
import {GetClassSkuUpgradeGuideDataList} from '@/axios/IDevice.js'

export default {
  props:{
    classsku:{
      type:String,
      default:''
    },
    deviceOnly:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      imgsrcDesc:[],
      isShow:false,
      identifNone:this.$t('devicecard.identifNone')
    }
  },
  watch:{
    classsku: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return
        this.doGetClassSkuUpgradeGuideDataList()
        this.isShow = true
      }
    }
  },

  methods:{
    handleChecked(){
      this.$emit('handleChecked',true)
    },
    doGetClassSkuUpgradeGuideDataList(){
      const param = {
        classSku:this.classsku,
        appType:4
      }
      GetClassSkuUpgradeGuideDataList(param,(rs) => {
        if (rs.StatusCode == this.$store.state.rightStatusCode) {
          if (rs.Result.length > 0) {
            this.imgsrcDesc = rs.Result
          } else {
            this.imgsrcDesc = [{
              // Type: 'img', Value: '../../static/device/identify/none.png'
              Type: 'img', Value: require('@static/device/identify/none.png')
            }, {
              Type: 'txt',
              Value: this.identifNone
            }]
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-boot{
  display: flex;
  align-items: center;
  margin: 20px 0;
  position: relative;
  .txt{
    margin-left: 20px;
  }
  .checked-bottom{
    position: absolute;
    left: 310px;
    bottom: 0px;
    margin-top: 150px;
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    border: 1px solid #0046AA;
    padding: 10px 76px;
    font-size: 12px;
    color: #0046AA;
    background: #fff;
  }
  .checked-bottom:hover{
    color: #fff;
    background: #0046AA;
    cursor: pointer;
  }
}
</style>
